// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.node-template {
    text-align: center;
}

.node-template strong {
    display: flex;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 0.25em;
    justify-content: center;
}

.node-template span {
    display: flex;
    padding: 0.25em;
}

h1 {
    text-align: center;
}

.hierarchy-viewer {
    display: block;
    padding: 15px 0;
}

.level1 {
    background-color: rgb(231, 228, 255);
}

.level2 {
    background-color: rgb(255, 237, 227);
}

.level3 {
    background-color: rgb(242, 248, 227);
}

.level4 {
    background-color: rgb(215, 238, 255);
}

.level5 {
    background-color: rgb(255, 252, 186);
}`, "",{"version":3,"sources":["webpack://./src/widgets/treeView.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".node-template {\n    text-align: center;\n}\n\n.node-template strong {\n    display: flex;\n    background-color: rgba(0, 0, 0, 0.1);\n    padding: 0.25em;\n    justify-content: center;\n}\n\n.node-template span {\n    display: flex;\n    padding: 0.25em;\n}\n\nh1 {\n    text-align: center;\n}\n\n.hierarchy-viewer {\n    display: block;\n    padding: 15px 0;\n}\n\n.level1 {\n    background-color: rgb(231, 228, 255);\n}\n\n.level2 {\n    background-color: rgb(255, 237, 227);\n}\n\n.level3 {\n    background-color: rgb(242, 248, 227);\n}\n\n.level4 {\n    background-color: rgb(215, 238, 255);\n}\n\n.level5 {\n    background-color: rgb(255, 252, 186);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
